import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Col,
  DatePicker,
  Divider,
  Form,
  InputNumber,
  Row,
  Select,
  Switch,
  Tooltip,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import React from "react";
import { useParams } from "react-router-dom";
import PayrollYearlySettingsService, { EmployeesNICategoryList } from "../../Services/PayrollYearlySettingsService";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddNIRate = ({ onDismiss, itemId, record, isViewOnly = false }: any) => {
  const [form] = useForm();
  const { id } = useParams();
  const { openNotification } = React.useContext(adminContext);

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    form.setFieldsValue({
      id: record?.id,
      niCategory: record?.niCategory,
      isAM: record?.isAM,
      payDateFrom: record?.payDateFrom ? dayjs(record?.payDateFrom) : undefined,
      payDateTo: record?.payDateTo ? dayjs(record?.payDateTo) : undefined,
      eeRateLEL: record?.eeRateLEL,
      eeRatePT: record?.eeRatePT,
      eeRateUST: record?.eeRateUST,
      eeRateAUST: record?.eeRateAUST,
      eeRateVUST: record?.eeRateVUST,
      eeRateFUST: record?.eeRateFUST,
      eeRateUEL: record?.eeRateUEL,
      eeRateAUEL: record?.eeRateAUEL,
      erRateST: record?.erRateST,
      erRateUST: record?.erRateUST,
      erRateAUST: record?.erRateAUST,
      erRateVUST: record?.erRateVUST,
      erRateFUST: record?.erRateFUST,
      erRateUEL: record?.erRateUEL,
      erRateAUEL: record?.erRateAUEL,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, record])

  return (
    <SAModal
      footer={isViewOnly ? null : undefined}
      title={itemId ? "Edit NI Rate item" : "Add NI Rate item"}
      width={900}
      open={true}
      okText={"Save"}
      cancelText={"Cancel"}
      okButtonProps={{ loading: loading }}
      // cancelButtonProps={{ loading: loading }}
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        setLoading(true);
        const yearlySettingsRecordId = id ?? "";
        const ItemId = itemId ?? "";
        // const values = form.validateFields();
        form.validateFields().then(async (values: any) => {
          const val = {
            ...values,
            id: record?.id,
            payDateFrom: values?.payDateFrom ? values?.payDateFrom.format("MM-DD-YYYY") : null,
            payDateTo: values?.payDateTo ? values?.payDateTo.format("MM-DD-YYYY") : null
          }
          let res = await PayrollYearlySettingsService.updateNIRatesItem(yearlySettingsRecordId, val, ItemId);
          if (res.status) {
            openNotification("success", "Details updated successfully")
            onDismiss(true);
            setLoading(false);
          } else {
            openNotification("error", res.message);
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      }}
    >
      <Form form={form} disabled={isViewOnly} requiredMark={false}>
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="NI Category"
              name="niCategory"
              rules={[{ required: true, message: "Select a NI Category" }]}
            >
              <Select
                placeholder="Select NI Category"
                className="select-height-28"
                // options={niCategoryOptions}
                options={EmployeesNICategoryList}
                optionRender={(option) => {
                  const tooltip = option.data?.tooltip;
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span>{option.label}</span>

                      <Tooltip title={tooltip}>
                        <InfoCircleOutlined
                          aria-label="info-circle"
                        // onClick={(e) => e.stopPropagation()}
                        />
                      </Tooltip>
                    </div>
                  );
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="PayDate From"
              name="payDateFrom"
              rules={[
                { required: true, message: "PayDate From is required" },
              ]}
            >
              <DatePicker
                placeholder="PayDate From"
                format='DD/MM/YYYY'
                style={{ width: "100%", height: 28 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="PayDate To"
              name="payDateTo"
              rules={[
                { required: true, message: "PayDate to is required" },
              ]}
            >
              <DatePicker
                placeholder="PayDate To"
                format='DD/MM/YYYY'
                style={{ width: "100%", height: 28 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Annual Method"
              name="isAM"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Divider
          orientation="left"
          orientationMargin="0"
          style={{ marginTop: "13px", marginBottom: "3px" }}
        >
          <p style={{ fontWeight: 650 }}> Employee's contribution limits</p>
        </Divider>

        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate LEL"
              name="eeRateLEL"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate LEL"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate PT"
              name="eeRatePT"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate PT"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate UST"
              name="eeRateUST"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate UST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate FUST"
              name="eeRateFUST"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate FUST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate AUST"
              name="eeRateAUST"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate AUST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate VUST"
              name="eeRateVUST"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate VUST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate UEL"
              name="eeRateUEL"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate UEL"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="EE Rate AUEL"
              name="eeRateAUEL"
            >
              <InputNumber
                controls={false}
                placeholder="EE Rate AUEL"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Divider
          orientation="left"
          orientationMargin="0"
          style={{ marginTop: "13px", marginBottom: "3px" }}
        >
          <p style={{ fontWeight: 650 }}>Employer's contribution limits</p>
        </Divider>
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate ST"
              name="erRateST"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate ST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate UST"
              name="erRateUST"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate UST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate FUST"
              name="erRateFUST"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate FUST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate AUST"
              name="erRateAUST"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate AUST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate VUST"
              name="erRateVUST"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate VUST"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate UEL"
              name="erRateUEL"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate UEL"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="ER Rate AUEL"
              name="erRateAUEL"
            >
              <InputNumber
                controls={false}
                placeholder="ER Rate AUEL"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SAModal>
  );
};

export default AddNIRate;